<div class="desktop-width-limiter edit-content-page page-padding">
    @if(eventFormStore.isLoading()) {
        <div class="loading">
            <mat-progress-spinner
                class="loading-spinner"
                [diameter]="250"
                mode="indeterminate"
                color="primary"
            />
        <div class="loading-text"><h1>Laden...</h1></div>
        </div>
    } @else {
        <div class="edit-event-container">
            <!-- Stepper Container -->
            <div class="stepper-container">
                <mat-stepper 
                    (selectionChange)="onStepChange($event)" 
                    [selectedIndex]="eventFormStore.currentStep()"
                    orientation="vertical"
                >
                @for (step of eventFormStore.steps(); track step; let i = $index) {
                    <mat-step [state]="step.state" [disabled]="step.disabled">
                        <ng-template matStepLabel>
                            <div class="step-content">
                                <span class="step-text">{{
                                    "event_steps." + step.title + ".label" | translate
                                }}</span>
                                <span class="step-box" [ngClass]="{
                                    'step-box-active': step.state === 'active',
                                    'step-box-completed': step.state === 'completed',
                                    'step-box-default': step.state === 'default',
                                    'step-box-disabled': step.disabled}"
                                ></span>
                            </div>
                        </ng-template>
                    </mat-step>
                }
                </mat-stepper>
            </div>

            <div class="content-container-wrapper">
                <div class="content-container">
                @switch (eventFormStore.currentStep()) {
                    @case(0) {
                        <media-upload-step [edit]="true" />
                    }
                    @case(1) {
                        <!-- 
                            The location selection step is rendered outside of the switch statement to preserve its state when
                            navigating between steps. --- IGNORE ---
                        -->
                    }
                    @case(2) {
                        <details-step [edit]="true" [formGroup]="streappFormGroup.controls.detailsForm" />
                    }
                    @case(3) {
                        <additonal-details-step [edit]="true" [formGroup]="streappFormGroup.controls.additionalDetailsForm" />
                    }
                    @case (4) {
                        <pricing-step [edit]="true" />
                    }
                    @case (5) {
                        <submit-step-edit-event [formGroup]="streappFormGroup" />
                    }
                }

                <location-selection-step
                    [edit]="true"
                    [initLatLng]="[eventFormStore.streappEvent().longtitude, eventFormStore.streappEvent().latitude]"
                    [formGroup]="streappFormGroup"
                    [style.display]="eventFormStore.currentStep() === 1 ? 'block' : 'none'"
                />

                <div class="navigation-buttons">
                    <!-- Previous Step -->
                    <div class="button-wrapper">
                    @if (eventFormStore.canGoBack()) {
                        <button matRipple (click)="previousStep()" class="secondary-button">
                            <mat-icon>keyboard_arrow_left</mat-icon>
                            {{ "general.previous" | translate | titlecase }}
                        </button>
                    }
                    </div>

                    <!-- Next Step -->
                    <div class="buttons-end">
                        <div class="button-wrapper">
                            <button matRipple (click)="cancel()" class="secondary-button cancel-button">
                                {{ "general.cancel" | translate | titlecase }}
                            </button>
                        </div>

                        <div class="button-wrapper">
                            @if ((eventFormStore.currentStep() !== 5))
                            {
                                <button matRipple [disabled]="!eventFormStore.canGoNext()" (click)="nextStep()" class="secondary-button">
                                    {{ "general.next" | translate | titlecase }}
                                    <mat-icon>keyboard_arrow_right</mat-icon>
                                </button>
                            }

                            <!-- Update streapp button -->
                            <div class="button-wrapper">
                                @if (eventFormStore.currentStep() === 5 && eventFormStore.isValid() && !eventFormStore.isLoading()) {
                                    @if (eventFormStore.isPublishing()) {
                                        <div class="publishing-text">
                                            <mat-progress-spinner
                                                class="loading-spinner"
                                                [diameter]="30"
                                                mode="indeterminate"
                                            ></mat-progress-spinner>
                                            <span>{{ "event_content.updating" | translate }}
                                                {{ eventFormStore.uploadItems().length > 0 ? eventFormStore.progress() : '' }}
                                            </span>
                                        </div>
                                    } @else {
                                        <button 
                                            matRipple id="submit" class="save-button" (click)="updateEvent()"
                                            [disabled]="!eventFormStore.isValid() || eventFormStore.isLoading() || eventFormStore.isPublishing()"
                                        >
                                            {{ "event_steps.step_publish.button_publish" | translate | titlecase }}
                                            <mat-icon>keyboard_arrow_right</mat-icon>
                                        </button>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    }
</div>


